export { default as AddAlternateContact } from "./AddAlternateContact/AddAlternateContact";
export { default as AddPassportDetail } from "./AddPassportDetail/AddPassportDetail";
export { default as AddTravellerDetails } from "./AddTravellerDetail/AddTravellerDetails";
export { default as AddTravellerDetailShimmer } from "./AddTravellerDetail/AddTravellerDetailShimmer";
export { default as AgentAgreementModal } from "./AgentAgreementModal/AgentAgreementModal";
export { default as BackDropComp } from "./BackDropComp/BackDropComp";
export { default as BulletListItem } from "./BulletListItem/BulletListItem";
export { default as CheckButton } from "./CheckButton/CheckButton";
export { default as ClaimYourInsurance } from "./ClaimYourInsurance/ClaimYourInsurance";
export { default as CommonModalDweb } from "./CommonModalDweb/CommonModalDweb";
export { default as ComparePlan } from "./ComparePlan/ComparePlan";
export { default as CountryCodeInput } from "./CountryCodeInput/CountryCodeInput";
export {
  default as DatePicker,
  default as DatePickerComp,
} from "./DatePickerComp/DatePickerComp";
export { default as DesktopLayout } from "./DesktopLayout/DesktopLayout";
export { default as DnldPolicyComponent } from "./DnldPolicyComponent/DnldPolicyComponent";
export { default as DomesticTrip } from "./DomesticTravelDetail/DomesticTrip";
export { default as EditTraveller } from "./EditTraveller/EditTraveller";
export { default as EditTravellerSheet } from "./EditTraveller/EditTravellerSheet";
export { default as ExcluciveOffers } from "./ExculsiveOffers/ExclusiveOffers";
export { default as FilterBottomComp } from "./FilterBottomComp/FilterBottomComp";
export { default as FilterPlans } from "./FilterPlans/FilterPlans";
export { default as FlexComp } from "./FlexComp/FlexComp";
export { default as FooterSectionComp } from "./FooterSectionComp/FooterSectionComp";
export { default as FormattedText } from "./FormattedText/FormattedText";
export { default as GreatChoice } from "./GreatChoice/GreatChoice";
export { default as GreatChoiceShimmer } from "./GreatChoice/GreatChoiceShimmer";
export { ImageComponent } from "./ImageComponent/ImageComponent";
export { default as ImageTag } from "./ImageTag/ImageTag";
export { default as InsuranceBooked } from "./InsuranceBooked/InsuranceBooked";
export { default as InsuranceBookedShimmer } from "./InsuranceBooked/InsuranceBookedShimmer";
export { default as BenefitItem } from "./InsurancePlans/BenefitItem";
export { default as InsPlanModalCommonInfo } from "./InsurancePlans/InsPlanModalCommonInfo";
export { default as InsurancePlans } from "./InsurancePlans/InsurancePlans";
export { default as InsurancePlansComp } from "./InsurancePlans/InsurancePlansComp";
export { default as InsurancePlansHeader } from "./InsurancePlans/InsurancePlansHeader";
export { default as InsurancePlanTypeSectionComp } from "./InsurancePlans/InsurancePlanTypeSection";
export { default as MoreBenefits } from "./InsurancePlans/MoreBenefits";
export { default as TravelAssistanceModal } from "./InsurancePlans/TravelAssistanceModal";
export { default as InsuranceStats } from "./InsuranceStats/InsuranceStats";
export { default as LandingButton } from "./LandingButton/LandingButton";
export { default as LandingButtonTertiary } from "./LandingButton/LandingButtonTertiary";
export { default as LandingButtonWhite } from "./LandingButton/LandingButtonWhite";
export { default as LandingFooter } from "./LandingFooter/LandingFooter";
export { default as LandingFooterInsurance } from "./LandingFooter/LandingFooterInsurance";
export { default as LandingHeader } from "./LandingHeader/LandingHeader";
export { default as LandingHeaderMobile } from "./LandingHeader/LandingHeaderMobile";
export { default as LandingInput } from "./LandingInput/LandingInput";
export { default as LandingTestimonials } from "./LandingTestimonials/LandingTestimonials";
export { default as ListingEditDetails } from "./ListingEditDetails/ListingEditDetails";
export { default as ListingTravelDetails } from "./ListingTravelDetails/ListingTravelDetails";
export { default as ManageInsurance } from "./ManageInsurance/ManageInsurance";
export { default as ManageInsuranceShimmer } from "./ManageInsurance/ManageInsuranceShimmer";
export { default as NoInsurancePlan } from "./NoInsurancePlan/NoInsurancePlan";
export { default as OrderDetailInsurance } from "./OrderDetailComp/OrderDetailInsurance";
export { default as OrderDetailPlan } from "./OrderDetailComp/OrderDetailPlan";
export { default as OrderDetailPlanShimmer } from "./OrderDetailComp/OrderDetailPlanShimmer";
export { default as OrderDetailTraveller } from "./OrderDetailComp/OrderDetailTraveller";
export { default as PrimaryContact } from "./OrderDetailComp/PrimaryContact";
export { default as OrderAmtPaid } from "./OrderDetailRightComp/OrderAmtPaid";
export { default as OrderGetHelp } from "./OrderDetailRightComp/OrderGetHelp";
export { default as OrderInsurance } from "./OrderDetailRightComp/OrderInsurance";
export { default as OrderPriceBreakup } from "./OrderDetailRightComp/OrderPriceBreakup";
export { default as OrderDetails } from "./OrderDetails/OrderDetails";
export { default as OrderDetailsShimmer } from "./OrderDetails/OrderDetailsShimmer";
export { default as OrderListingComp } from "./OrderListingComp/OrderListingComp";
export { default as OrderStatusComp } from "./OrderStatusComp/OrderStatusComp";
export { default as AddPassportModal } from "./PassportNumComp/AddPassportModal";
export { default as PassportNumComp } from "./PassportNumComp/PassportNumComp";
export { default as PaymentStatusComp } from "./PaymentStatusComp/PaymentStatusComp";
export { default as PersuasionBanner } from "./PersuasionBanner/PersuasionBanner";
export { default as PersuasionBannerInsurance } from "./PersuasionBanner/PersuasionBannerInsurance";
export { default as RadioButton } from "./RadioButton/RadioButton";
export { default as RangeDatePicker } from "./RangeDatePicker/RangeDatePicker";
export { default as ReactPortalComp } from "./ReactPortalComp";
export { default as SafenSecureTrav } from "./SafenSecureTrav/SafenSecureTrav";
export { default as SectionDividers } from "./SectionDividers/SectionDividers";
export { default as SecureTravOffer } from "./SecureTravOffer/SecureTravOffer";
export { default as SelectCountryCodeModal } from "./SelectCountryModal/SelectCountryCodeModal";
export { default as SelectCountryModalSheetV2 } from "./SelectCountryModal/SelectCountryModalSheetV2";
export { default as SelectCountryModalV2 } from "./SelectCountryModal/SelectCountryModalV2";
export { default as Shimmer } from "./Shimmer/Shimmer";
export { default as ShimmerVersion2 } from "./Shimmer/ShimmerVersion2";
export { default as ShimmerVersion3 } from "./Shimmer/ShimmerVersion3";
export { default as ShowInsPlan } from "./ShowInsPlan/ShowInsPlan";
export { default as Spinner } from "./Spinner/Spinner";
export { default as Tags } from "./Tags/Tags";
export { default as AnchorTag } from "./TextStyles/AnchorTag";
export { default as H2Tag } from "./TextStyles/H2Tag";
export { default as H3Tag } from "./TextStyles/H3Tag";
export { default as H4Tag } from "./TextStyles/H4Tag";
export { default as H5Tag } from "./TextStyles/H5Tag";
export { default as H6Tag } from "./TextStyles/H6Tag";
export { default as ParaTag } from "./TextStyles/ParaTag";
export { default as SpanTag } from "./TextStyles/SpanTag";
export { default as TMFloatingInput } from "./TMFloatingInput/TMFloatingInput";
export { default as TmNPSFeedback } from "./TMNPSFeedback";
export { default as Toast } from "./Toast/Toast";
export { default as ToastCompare } from "./Toast/ToastCompare";
export { default as ToolTipComp } from "./ToolTipComp/ToolTipComp";
export { default as TravAssistant } from "./TravAssistant/TravAssistant";
// export { default as LandingFaq } from "./LandingFaq/LandingFaq";
export { default as TravellingTo } from "./TravelDetails/TravellingTo";
export { default as TravellingToShimmer } from "./TravelDetails/TravellingToShimmer";
export { default as TravellingToWidget } from "./TravellingToWidget/TravellingToWidget";
export { default as WhatsCovered } from "./WhatsCovered/WhatsCovered";
export { default as WhyBuyTravIns } from "./WhyBuyTravIns/WhyBuyTravIns";
